import StorageService from "@infrastructure/Services/StorageService";

const prefix = StorageService.STORAGE_PREFIX;
const storage = window.localStorage;

function getItem(itemKey: string): string | null {
    return storage.getItem(prefix + itemKey);
}

function setItem(itemKey: string, value: string) {
    return storage.setItem(prefix + itemKey, value ? value : "");
}

function removeItem(itemKey: string) {
    return storage.removeItem(prefix + itemKey);
}

function clear() {
    return storage.clear();
}

export default {
    getItem,
    setItem,
    removeItem,
    clear,
};
